import { Button, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import moment from 'moment/moment';
import { useContext, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import ErrorSnackbarNotification from '../../common/ErrorHandling/ErrorSnackbarAlert';
import { LanguageContext } from "../../common/features/LanguageWrapper";
import { styles } from '../../style/style';
import { add, setOrderRequestSearchType, setOrderRequestSearchField } from '../orderlist/orderListSlice';
import { ActualTargetFrom, ActualTargetTo, AdvancedSearchAppName, AdvancedSearchClearButton, AllocationGroupText, ChargeToBacLabel, ChargeToBacText, ChargeToBfc, DanText, Division, EndUserText, EventCodeFrom, EventCodeTo, Model, ModelYear, OrderNumber, PrimaryFanLabel, PrimaryFanText, PurchaseNumber, RecordsToReturn, RequestTargetFrom, RequestTargetTo, ShipToBac } from './AdvancedSearchComponents';
/* import dayjs from 'dayjs'; */
import 'dayjs/locale/fr';
import log from '../../common/components/Logger'





export default function AdvancedSearch() {
    const login = useSelector((state) => state.login.data.payload.login);

    if (!login) {
        window.location.href = '/home';
    }


    const intl = useIntl();
    const [defaultEventFrom, setDefaultEventFrom] = useState("");
    const [defaultEventTo, setDefaultEventTo] = useState("");
    const [modelYear, setModelYear] = useState([]);
    const [defaultRecordsToReturn, setDefaultRecordToReturn] = useState('All');
    const [modelYearRequired, setModelYearRequired] = useState("");
    const [selectedModelYear, setSelectedModelYear] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [error, setError] = useState(false);
    const [errorType, setErrorType] = useState("");
    const [primaryFan, setPrimaryFan] = useState('');
    const [endUserFan, setEndUserFan] = useState('');
    const [bacNumber, setBacNumber] = useState('');
    const [chargeToBfc, setChargeToBfc] = useState('');
    const [shipBfc, setShipBac] = useState('');
    const [allocationGroup, setAllocationGroup] = useState('');
    const [dan, setDan] = useState('');
    const [purchaseNum, setPurchaseNum] = useState('');
    const [orderNum, setOrderNum] = useState('');
    const [division, setDivision] = useState([]);
    const [selectedDivision, setSelectedDivision] = useState("");
    const [model, setModel] = useState([]);
    const [distinctModel, setDistinctModel] = useState([]);
    const [selectedModel, setSelectedModel] = useState('');
    const [eventCodeList, setEventCodeList] = useState([]);
    const [selectedEventCodeFrom, setSelectedEventCodeFrom] = useState('');
    const [selectedEventCodeTo, setSelectedEventCodeTo] = useState('');
    const [requestTargetFrom, setRequestTargetFrom] = useState(null);
    const [requestTargetTo, setRequestTargetTo] = useState(null);
    const [actualTargetFrom, setActualTargetFrom] = useState(null);
    const [actualTargetTo, setActualTargetTo] = useState(null);
    const [recordsToReturn, setRecordsToReturn] = useState('');
    const recordsToReturnList = ['All','50', '100', '250', '500', '1000']
    const dispatch = useDispatch();
    const ApiList = useSelector((state) => state.apiList.apiList);
    const [bacFixed, setBacFixed] = useState(false);
    const [primaryFanFixed, setPrimaryFanFixed] = useState(false);
    const [hideEndUserFan, setHideEndUserFan] = useState(true);
    const userDetails = useSelector((state) => state.user.data.payload);
    /* const idToken = localStorage.getItem("idToken") */
    const [loading, setLoading] = useState(false);


    const context = useContext(LanguageContext);
    let calendarLocale;
    if (localStorage.getItem('locale') !== null || localStorage.getItem('locale') === "") {
        if (localStorage.getItem('locale') == "fr-CA") {
            calendarLocale = "fr";
        }
        else {
            calendarLocale = "en";
        }
    } else {
        if (context.locale === "fr-CA") {
            calendarLocale = "fr";
        } else {
            calendarLocale = "en";
        }
    }


    /* const [tryFrom, setTryFrom] = useState(null); */
    /* const tryRequestTargetFrom = (event) => {
        let formattedDate = moment(event).format('YYYY-MM-DD');
        setTryFrom(formattedDate);
    }; */



    let config;
    const url = ApiList.getsearchinputbyrole;
    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'guid': `${ApiList.guid}`
        },
    };

    useEffect(() => {
        const data = {
            user: {
                userId: userDetails.userId,
                partnerType: userDetails.partnerType,
                preferredLanguage: userDetails.preferredLanguage,
                bac: userDetails.bac,
                primaryFan: userDetails.primaryFAN
            }
        }

        config = {
            headers: {
                'Content-Type': 'application/json',
                'guid': `${ApiList.guid}`
            }
        };

        axios.post(url, data, config)
            .then((response) => {
                log.info(`fos_ui_log: AdvancedSearch():getsearchinputbyrole ${response.data.statusMessage}`)
                if (response.status === 200) {
                    setError(false)
                    if (response.data.bacFixed === true) {
                        setBacNumber(response.data.bac)
                        setBacFixed(true);
                    }
                    if (response.data.primaryFanFixed === true) {
                        setPrimaryFan(response.data.primaryFan)
                        setPrimaryFanFixed(true);
                    }
                    if (response.data.hideEndUserFan === false) {
                        setHideEndUserFan(false);
                    }
                }
            })
            .catch((error) => {
                setError(true);
                setLoading(false);
                setErrorType('error')
                setErrorMessage(intl.formatMessage({ id: error.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: error.message }))
                log.error(`fos_ui_log: AdvancedSearch():getsearchinputbyrole ${error.message}`)
            })
    }, [primaryFan, bacNumber])

    // window.addEventListener ( "pageshow", function (event) {
    //     var historyTraversal = event.persisted ||
    //                             ( typeof this.window.performance != "undefinded" &&
    //                                 this.window.performance.navigation.type === 2);
    //     if (historyTraversal ) {
    //         this.window.location.reload();
    //     }

    // });

    function handleSearch() {
        const url = ApiList.advancedOrderList;
        setError(false);
        setLoading(true);
        setErrorMessage('');

        if (selectedModelYear.length === 0) {
            setModelYearRequired(intl.formatMessage({ id: "ordersummary.modelYearRequired", defaultMessage: "Model Year is Required" }))
        } else {
            setModelYearRequired("")
        }

        let divisionValue = selectedDivision.split(' ')[2];
        let eventCodeFrom;
        let eventCodeTo;
        if (selectedEventCodeFrom === '') {
            eventCodeFrom = defaultEventFrom.split(' ')[0];
        }
        else {
            eventCodeFrom = selectedEventCodeFrom.split(' ')[0];
        }

        if (selectedEventCodeTo === '') {
            eventCodeTo = defaultEventTo.split(' ')[0];
        }
        else {
            eventCodeTo = selectedEventCodeTo.split(' ')[0];
        }


        let data = {
            advancedSearch: {
                primaryFleetAccountNumber: primaryFan,
                endUserFleetAccountNumber: endUserFan,
                chargeToBac: bacNumber,
                chargeToBfc: chargeToBfc,
                shipToBac: shipBfc,
                dealerCode: dan,
                allocationGroup: allocationGroup,
                model: selectedModel,
                modelYear: selectedModelYear.toString(),
                requestedTpwFrom: requestTargetFrom,
                requestedTpwTo: requestTargetTo,
                actualTpwFrom: actualTargetFrom,
                actualTpwTo: actualTargetTo,
                orderNumber: orderNum,
                poNumber: purchaseNum,
                eventCodeFrom: eventCodeFrom,
                eventCodeTo: eventCodeTo,
                recordsToReturn: recordsToReturn,
                partnerType: userDetails.partnerType,
                division: divisionValue
            }
        }

        config = {
            headers: {
                'Content-Type': 'application/json',
                'guid': `${ApiList.guid}`
            }
        };


        let navigatePath = '/orderrequestlist';


        dispatch(setOrderRequestSearchType('OrderList'));
        dispatch(setOrderRequestSearchField(data));
        window.location.href = navigatePath;

        /*
        axios.post(url, data, config)
            .then((response) => {
                if (response.data.advancedSearchValid === true) {

                    if (response.data.statusMessage === 'SUCCESS') {
                        log.info(`fos_ui_log: AdvancedSearch():handleSearch: ${response.data.statusMessage}`)

                        // limit the data to only 8000 lines or below 
                        const orderRequestList = response.data.orderRequestList.length > 7000 ? response.data.orderRequestList.slice(0, 7000) :response.data.orderRequestList;
                        const newData = {...response.data, orderRequestList: orderRequestList}
                        setLoading(false);
                        dispatch(add(newData));
                        dispatch(setOrderRequestSearchType('leftClick'));
                        window.location.href = navigatePath;
                    }
                    else {
                        setError(true);
                        setLoading(false);
                        setErrorType('error');
                        if (response.data.statusMessage !== null) {
                            setErrorMessage(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }))
                            log.info(`fos_ui_log: AdvancedSearch():handleSearch: ${response.data.statusMessage}`)
                        }
                    }

                } else {
                    setError(true);
                    setLoading(false);
                    let errorMessage = [];
                    if (response.data.invalidPrimaryFanMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.invalidPrimaryFanMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch():invalidPrimaryFanMessage: ${response.data.invalidPrimaryFanMessage}`)
                    }
                    if (response.data.invalidEndUserFanMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.invalidEndUserFanMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch():invalidEndUserFanMessage: ${response.data.invalidEndUserFanMessage}`)
                    }
                    if (response.data.invalidChargeToBacMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.invalidChargeToBacMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch():invalidChargeToBacMessage: ${response.data.invalidChargeToBacMessage}`)
                    }
                    if (response.data.invalidChargeToBfcMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.invalidChargeToBfcMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch():invalidChargeToBfcMessage: ${response.data.invalidChargeToBfcMessage}`)
                    }
                    if (response.data.invalidShipToBacMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.invalidShipToBacMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch():invalidShipToBacMessage: ${response.data.invalidShipToBacMessage}`)
                    }
                    if (response.data.statusMessage !== '' && response.data.statusMessage !== null) {
                        errorMessage.push(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }));
                        log.info(`fos_ui_log: AdvancedSearch(): ${response.data.statusMessage}`)
                    }
                    setErrorType('error');
                    setErrorMessage(errorMessage);
                }
            })
            .catch((error) => {
                setError(true);
                setLoading(false);
                setErrorType('error');
                setErrorMessage(intl.formatMessage({ id: error.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: error.message }))
                log.error(`fos_ui_log: AdvancedSearch():handleSearch ${error.message}`)
            })*/

    }


    useEffect(() => {
        axios.get(ApiList.getModelYear, headerConfig)
            .then((res) => {
                setModelYear(res.data.activeYears)
                setSelectedModelYear([res.data.activeYears[res.data.activeYears.length - 1]])
                log.info(`fos_ui_log: AdvancedSearch():getModelYear ${res.data.activeYears}`)
                axios.get(ApiList.getModel,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'guid': `${ApiList.guid}`
                        },
                        params: {
                            year: res.data.activeYears[res.data.activeYears.length - 1]
                        }
                    })
                    .then((res2) => {
                        setModel(res2.data.modelList)
                        setDistinctModel(res2.data.distinctModelList)
                        log.info(`fos_ui_log: AdvancedSearch():getModel ${res2.data.modelList}`)
                    }).catch((error) => {
                        log.error(`fos_ui_log: AdvancedSearch():getModel ${error.message}`)
                    })
            })
            .catch((error) => {
                log.error(`fos_ui_log: AdvancedSearch():getModelYear ${error.message}`)
            })

    }, []);

    useEffect(() => {
        axios.get(ApiList.getDivision, headerConfig)
            .then((res) => {
                setDivision(res.data.divisionList)
                log.info(`fos_ui_log: AdvancedSearch():getDivision ${res.data.divisionList}`)
            }).catch((error) => {
                log.error(`fos_ui_log: AdvancedSearch():getDivision ${error.message}`)
            })
    }, []);

    useEffect(() => {
        axios.get(ApiList.advancedOrderList, headerConfig)
            .then((res) => {
                setDefaultRecordToReturn(res.data.recordsToReturnList[0])
                log.info(`fos_ui_log: AdvancedSearch():advancedOrderList ${res.data.recordsToReturnList}`)
            }).catch((error) => {
                log.error(`fos_ui_log: AdvancedSearch():advancedOrderList ${error.message}`)
            })
    }, []);

    useEffect(() => {
        const eventconfig = {
            headers: {
                'Content-Type': 'application/json',
                'guid': `${ApiList.guid}`
            },
            params: {
                partnerType: userDetails.partnerType
            }
        };
        if (eventCodeList.length === 0) {
            axios.get(ApiList.getEventCodes, eventconfig)
                .then((res) => {
                    setEventCodeList(res.data.eventCodeList)
                    setDefaultEventFrom(res.data.eventCodeList[0].vehEventCodes)
                    setDefaultEventTo(res.data.eventCodeList[res.data.eventCodeList.length - 1].vehEventCodes)
                    log.info(`fos_ui_log: AdvancedSearch():getEventCodes ${res.data.eventCodeList}`)
                })
                .catch((error) => {
                    log.error(`fos_ui_log: AdvancedSearch():getEventCodes ${error.message}`)
                })
        }
    }, []);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        if (event.target.value.includes("ALL")) {
            axios.get(ApiList.getModelYear, headerConfig)
                .then((res) => {
                    setSelectedModelYear(res.data.activeYears)
                    log.info(`fos_ui_log: AdvancedSearch():getModelYear ${res.data.activeYears}`)
                })
                .catch((error) => {
                    log.error(`fos_ui_log: AdvancedSearch():getModelYear ${error.message}`)
                })
        } else {
            setSelectedModelYear(
                // On autofill we get a stringified value.
                typeof value === 'string' ? value.split(',') : value,
            )
        }

        axios.get(ApiList.getModel,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'guid': `${ApiList.guid}`
                },
                params: {
                    year: event.target.value.toString()
                }
            })
            .then((res) => {
                setModel(res.data.modelList)
                setDistinctModel(res.data.distinctModelList)
                log.info(`fos_ui_log: AdvancedSearch():getModel ${res.data.modelList}`)
            }).catch((error) => {
                log.error(`fos_ui_log: AdvancedSearch():getModel ${error.message}`)
            })
    };

    const handleDivChange = (event) => {
        setSelectedDivision(event.target.value);
    };

    const handleModelChange = (event) => {
        setSelectedModel(event.target.value);
    };

    const handleEventCodeFrom = (event) => {
        setSelectedEventCodeFrom(event.target.value);
    };

    const handleEventCodeTo = (event) => {
        setSelectedEventCodeTo(event.target.value);
    };

    const onChangePrimaryFan = (event) => {
        setPrimaryFan(event.target.value);
    }

    const onChangeEndUserFan = (event) => {
        setEndUserFan(event.target.value);
    }

    const onChangeChargeToBfc = (event) => {
        setChargeToBfc(event.target.value);
    }

    const onChangeShipBac = (event) => {
        setShipBac(event.target.value);
    }
    const onChangeChargeToBac = (event) => {
        setBacNumber(event.target.value);
    }

    const onChangeAllocationGroup = (event) => {
        setAllocationGroup(event.target.value);
    }

    const onChangeDan = (event) => {
        setDan(event.target.value);
    }

    const onChangePurchaseNum = (event) => {
        setPurchaseNum(event.target.value);
    }


    const onChangeOrderNum = (event) => {
        setOrderNum(event.target.value);
    }


    const handleRequestTargetFrom = (event) => {
        /* setRequestTargetFrom(event.target.value); */
        let formattedDate = moment(event).format('YYYY-MM-DD');
        setRequestTargetFrom(formattedDate);
    };



    const handleRequestTargetTo = (event) => {
        /* setRequestTargetTo(event.target.value); */
        let formattedDate = moment(event).format('YYYY-MM-DD');
        setRequestTargetTo(formattedDate);
    };

    const handleActualTargetFrom = (event) => {
        /* setActualTargetFrom(event.target.value); */
        let formattedDate = moment(event).format('YYYY-MM-DD');
        setActualTargetFrom(formattedDate);
    };

    const handleActualTargetTo = (event) => {
        /* setActualTargetTo(event.target.value); */
        let formattedDate = moment(event).format('YYYY-MM-DD');
        setActualTargetTo(formattedDate);
    };

    const handleRecordsToReturn = (event) => {
        setRecordsToReturn(event.target.value);
    };

    const handleClose = (reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setError(false);
    };

    const clearForm = () => {

        if (userDetails.parterType === "GM_Corporate" || userDetails.parterType === "GM_Wholesale") {
            setBacNumber('');
        }

        setPrimaryFan(''); setEndUserFan('');
        setChargeToBfc(''); setShipBac('');
        setBacNumber('')
        setSelectedModelYear([]);
        setSelectedDivision(''); setSelectedModel(''); setSelectedEventCodeFrom('');
        setDan(''); setAllocationGroup(''); setRequestTargetFrom(null); setRequestTargetTo(null);
        setActualTargetFrom(null); setActualTargetTo(null); setOrderNum('');
        setPurchaseNum(''); setSelectedEventCodeFrom('');
        setSelectedEventCodeTo(''); setRecordsToReturn('');
        setErrorMessage('');
        setModelYearRequired('');
    }

    return (
        <Box sx={{width: '100vw', overflowX: 'hidden'}}>
            <Grid container sx={styles.masterMargin}>
                <Grid item xs={12}>
                    <Grid id='advancedSearchAppName'>
                        <AdvancedSearchAppName />
                    </Grid>
                    <Stack spacing={2} sx={styles.orderSummaryStack}>
                        <Stack spacing={3} direction='row'>
                            <Grid item xs={6}>
                                {userDetails.partnerType !== 'FLEET' && (<Typography id='fanLabel' variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.primaryfan" defaultMessage="Primary Fleet Account Number (FAN)" /></Typography>)}
                                {userDetails.partnerType === 'FLEET' && (<Typography id='fanLabel' variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.fan" defaultMessage="Fleet Account Number (FAN)" /></Typography>)}
                            </Grid>
                            <Grid item xs={6}>
                                <Typography id="bacLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.BAC" defaultMessage="Business Associate Code (BAC)" /></Typography>
                            </Grid>
                        </Stack>

                        <Stack spacing={3} direction='row'>
                            {primaryFanFixed === true ? (
                                <Grid id='primaryFanLabel' item xs={3}>
                                    <PrimaryFanLabel primaryFan={primaryFan} />
                                </Grid>
                            ) : (
                                <Grid id='primaryFanText' item xs={3}>
                                    <PrimaryFanText value={primaryFan} id='primaryFan' onChangePrimaryFan={onChangePrimaryFan} />
                                </Grid>
                            )}

                            <Grid id='endUserFanGrid' item xs={3}>
                                {hideEndUserFan === false ? (
                                    <EndUserText value={endUserFan} id='endUserFan' onChangeEndUserFan={onChangeEndUserFan} />
                                ) : (
                                    null
                                )}
                            </Grid>

                            {bacFixed === true ? (
                                <Grid id='chargeToBacGridLabel' item xs={3}>
                                    <ChargeToBacLabel bacNumber={bacNumber} />
                                </Grid>
                            ) : (
                                <Grid id='chargeToBacGridText' item xs={3}>
                                    <ChargeToBacText value={bacNumber} id='chargeToBac' onChangeChargeToBac={onChangeChargeToBac} />
                                </Grid>
                            )}
                            <Grid id='shipToBac' item xs={3}>
                                <ShipToBac value={shipBfc} id='shipBac' onChangeShipBac={onChangeShipBac} />
                            </Grid>
                        </Stack>
                    </Stack>


                    <Stack spacing={2} sx={styles.advancedSearchStack}>
                        <Stack spacing={3} direction='row'>
                            <Grid item xs={3}>
                                <Typography id="bfcLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.businessFunctionCode" defaultMessage="Business Function Code (BFC)" /></Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography id="danLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.dealerAssignedNumber" defaultMessage="Dealer Assigned Number (DAN)" /></Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography id="orderNumberLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.orderNumber" defaultMessage="Order Number" /></Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography id="purchaseOrderLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.purchaseOrderNumber" defaultMessage="Purchase Order (PO) Number" /></Typography>
                            </Grid>
                        </Stack>

                        <Stack spacing={3} direction='row'>
                            <Grid item xs={3}>
                                <Stack spacing={3} >
                                    <Grid id='chargeToBfc' item xs={12}>
                                        <ChargeToBfc value={chargeToBfc} id='chargeToBfc' onChangeChargeToBfc={onChangeChargeToBfc} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <Grid item xs={3}>
                                <Stack spacing={3} >
                                    <Grid id='dan' item xs={12}>
                                        <DanText value={dan} id='dan' onChangeDan={onChangeDan} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <Grid item xs={3}>
                                <Stack spacing={3} direction='row'>
                                    <Grid id='orderNumber' item xs={12}>
                                        <OrderNumber value={orderNum} id='orderNum' onChangeOrderNum={onChangeOrderNum} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <Grid item xs={3}>
                                <Stack spacing={3} direction='row'>
                                    <Grid id='purchaseOrder' item xs={12}>
                                        <PurchaseNumber value={purchaseNum} id='purchaseNum' onChangePurchaseNum={onChangePurchaseNum} />
                                    </Grid>
                                </Stack>
                            </Grid>
                        </Stack>
                    </Stack>


                    <Stack>
                        <Stack spacing={2} sx={styles.advancedSearchStack}>
                            <Typography id="vehicleInfoLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.vehicleInformation" defaultMessage="Vehicle Information" /></Typography>

                            <Stack spacing={3} direction='row'>
                                <Grid id='modelYear' item xs={3}>
                                    <ModelYear options={modelYear} value={selectedModelYear} handleChange={handleChange} modelYearRequired={modelYearRequired} />
                                </Grid>
                                <Grid id='division' item xs={3}>
                                    <Division options={division} value={selectedDivision} handleDivChange={handleDivChange} />
                                </Grid>
                                <Grid id='allocationGroup' item xs={3}>
                                    <AllocationGroupText value={allocationGroup} id='allocationGroup' onChangeAllocationGroup={onChangeAllocationGroup} />
                                </Grid>
                                <Grid id='model' item xs={3}>
                                    <Model selectedDivision={selectedDivision} selectedModelYr={selectedModelYear} distinctModel={distinctModel} options={model} value={selectedModel} handleModelChange={handleModelChange} />
                                </Grid>
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack spacing={4} direction='row' sx={styles.advancedSearchStack}>
                        <Grid item xs={6}>
                            <Stack spacing={3} >
                                {/* <Typography id="orderNumberLabel" variant="h4" sx={styles.h4InformationGroupHeader} >Order Number</Typography>
                                <Stack spacing={3} direction='row'>
                                    <Grid id='orderNumber' item xs={6}>
                                        <OrderNumber value={orderNum} id='orderNum' onChangeOrderNum={onChangeOrderNum} />
                                    </Grid>
                                </Stack> */}
                                <Typography id="requestTargetLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.requestedTargetProductionWeek" defaultMessage="Requested Target Production Week (TPW)" /></Typography>

                                <Stack spacing={3} direction='row'>
                                    <Grid id='requestTargetFrom' item xs={6}>
                                        <RequestTargetFrom calendarLocale={calendarLocale} disableToDate={requestTargetTo} requestTargetFrom={requestTargetFrom} handleRequestTargetFrom={handleRequestTargetFrom} />
                                    </Grid>
                                    <Grid id='requestTargetTo' item xs={6}>
                                        <RequestTargetTo calendarLocale={calendarLocale} disableFromDate={requestTargetFrom} requestTargetTo={requestTargetTo} handleRequestTargetTo={handleRequestTargetTo} />
                                    </Grid>
                                </Stack>

                                <Typography id="eventCodeLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.eventCode" defaultMessage="Event Code" /></Typography>
                                <Stack spacing={3} direction='row'>
                                    <Grid id='eventCodeFrom' item xs={6}>
                                        <EventCodeFrom defaultEventFrom={defaultEventFrom} options={eventCodeList} value={selectedEventCodeFrom} handleEventCodeFrom={handleEventCodeFrom} />
                                    </Grid>
                                    <Grid id='eventCodeTo' item xs={6}>
                                        <EventCodeTo defaultEventTo={defaultEventTo} options={eventCodeList} value={selectedEventCodeTo} handleEventCodeFrom={handleEventCodeTo} />
                                    </Grid>
                                </Stack>
                            </Stack>

                        </Grid>
                        <Grid item xs={6}>
                            <Stack spacing={3} >
                                {/* <Typography id="purchaseOrderLabel" variant="h4" sx={styles.h4InformationGroupHeader} >Purchase Order (PO) Number</Typography>
                                <Stack spacing={3} direction='row'>
                                    <Grid id='purchaseOrder' item xs={6}>
                                        <PurchaseNumber value={purchaseNum} id='purchaseNum' onChangePurchaseNum={onChangePurchaseNum} />
                                    </Grid>
                                </Stack> */}
                                <Typography id="actualTargetLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.actualTargetProductionWeek" defaultMessage="Actual Target Production Week (TPW)" /></Typography>
                                <Stack spacing={3} direction='row'>
                                    <Grid id='actualTargetFrom' item xs={6}>
                                        <ActualTargetFrom calendarLocale={calendarLocale} disableToDate={actualTargetTo} actualTargetFrom={actualTargetFrom} handleActualTargetFrom={handleActualTargetFrom} />
                                    </Grid>
                                    <Grid id='actualTargetTo' item xs={6}>
                                        <ActualTargetTo calendarLocale={calendarLocale} disableFromDate={actualTargetFrom} actualTargetTo={actualTargetTo} handleActualTargetTo={handleActualTargetTo} />
                                    </Grid>
                                </Stack>
                                <Typography id="recordsToReturnLabel" variant="h4" sx={styles.h4InformationGroupHeader} ><FormattedMessage id="advancedsearchcomponents.recordstoreturn" defaultMessage="Records To Return" /></Typography>
                                <Stack>
                                    <Grid id='recordsToReturn' item xs={6}>
                                        <RecordsToReturn defaultRecordsToReturn={defaultRecordsToReturn} value={recordsToReturn} options={recordsToReturnList} onChange={handleRecordsToReturn} />
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Grid>
                    </Stack>
                    <Grid id='buttons'>
                        <Stack direction='row' spacing={2} sx={styles.orderSummaryStackButton}>
                            <AdvancedSearchClearButton onChange={clearForm} />
                            {loading !== true ? (
                                <Button id="searchButton" sx={styles.orderSummarySearch} onClick={handleSearch} ><FormattedMessage id='ordersummarycomponents.search' defaultMessage='Search' /></Button>
                            ) : (
                                <Button sx={styles.orderSummarySearch}><CircularProgress sx={styles.loadingSpinner} size={20} /></Button>
                            )}
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
            {errorMessage.length > 0 &&
                <ErrorSnackbarNotification errorType={errorType} open={error} handleClose={handleClose} errorMessage={errorMessage} />
            }
            {/* <ToastNotification type={'error'} open={error} handleAlert={() => {setError(false)}} autoHideDuration={5000} message={errorMessage} /> */}
        </Box>
    )
}
